<div class="live-product" *ngIf="products">
  <mat-card class="live-product-title">
      <mat-card-content>
          <span class="live-product-title-order">สินค้า ({{products.length}})</span>
        <button mat-flat-button role="button" class="live-product-clear" (click)="closeDialog()">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-card-content>
  </mat-card>
  <div class="container" *ngFor="let product of products">
      <mat-card class="live-product-card">
          <div class="row product-item">
              <div class="product-image col-3">
                  <img [src]="product?.imageUrl" width="61" height="61"/>
              </div>
              <div class="product-detail col-6 pr-0">
                  <div class="row live-group-product-name">
                      <span class="live-product-name">{{product?.name}}</span>
                  </div>
                  <div class="row live-group-price">
                      <span class="live-product-sellPrice">฿{{product?.sellingPrice}}</span>
                      <span class="live-product-price ml-2">฿{{product?.basePrice}}</span>
                  </div>
              </div>
              <div class="product-link col-3 pr-0">
                  <a class="live-product-cart-link" *ngIf="product && product.link" [href]="product?.link" target="_blank" rel="noopener noreferrer">
                      <div class="live-shopping">
                        <span class="live-shopping-button">ช๊อปเลย</span>
                      </div>
                  </a>
              </div>
          </div>
      </mat-card>
  </div>
</div>
